/**
 * Centralized frontend logger.
 *
 * Wraps console.warn and console.error so all application warning and error
 * output goes through a single point.
 *
 * For temporary local troubleshooting, developers may use console.warn,
 * console.error, console.debug, or console.info directly — just don't commit
 * the debug/info calls, as they are flagged by ESLint.
 */

const logger = {
  warn(...args) {
    console.warn(...args);
  },
  error(...args) {
    console.error(...args);
  },
};

export default logger;
